var _defs, _rect, _rect2, _rect3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnfollowmonkeyHands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192.3,
    height: 147.67,
    viewBox: "0 0 192.3 147.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:url(#a);}.c{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 16.21,
    y1: 78.66,
    x2: 16.21,
    y2: -4.99,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 150)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e22ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#3123ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3b25ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#4c29a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#642ea7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#8335a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a83ea1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#d4489d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e24b9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 176.08,
    y1: 78.66,
    x2: 176.08,
    y2: -4.99,
    xlinkHref: "#a"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0,
    y: 120.23,
    width: 192.3,
    height: 37.44
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 0.79,
    y: 112.84,
    width: 30.84,
    height: 34.83,
    rx: 10.01
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 160.66,
    y: 112.84,
    width: 30.84,
    height: 34.83,
    rx: 10.01
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfollowmonkeyHands);
export default __webpack_public_path__ + "static/media/unfollowmonkey-hands.06bd9d8ccfbea8100f2b0a2a29f8ad60.svg";
export { ForwardRef as ReactComponent };